import React from "react";
import AcquireWebComponent from "../framework/MaterialUI";
import { Link } from "react-router-dom";

class MySettingsNavigator extends AcquireWebComponent {
  render() {
    const { activeIndex, client } = this.props;
    const showInsightsFileSetup =
      client &&
      client.subscription &&
      client.subscription.name.toLowerCase().indexOf("basic") < 0;
    /*
		switch(activeIndex){
			case 1:
				return (
					<div className="page-navigation">
						<div className='pull-left page-nav-tab pl-20 text-left pr-20'>
							<strong><Link to="/settings/tags/list">TAGS</Link></strong>
						</div>
						{
							showInsightsFileSetup && 
							<div className="pull-left page-nav-tab-active ">
								<strong>INSIGHTS FILE SETUP</strong>
							</div>
						}
					</div>
				)
			default:
				return (
					<div className="page-navigation">
						<div className='pull-left page-nav-tab-active'>
							<strong>Tags</strong>
						</div>
						{
							showInsightsFileSetup && 

							<div className="pull-left page-nav-tab pl-20 text-left pr-20">
								<strong><Link to="/settings/insights" >Insights File Setup</Link></strong>
							</div>
						}
					</div>
				)
		}*/
    return (
      <div id="left-nav" style={{ flex: "0 0 290px" }}>
        <div className="light-grey-border">
          <div
            onClick={() => {
              this.props.history.push(
                "/settings/tags/list?cid=" + this.props.selected_client,
              );
            }}
            style={{ height: "58px", padding: "15px 20px 15px 35px" }}
            className={
              activeIndex !== 1
                ? "tag-settings-type-active"
                : "tag-settings-type"
            }
          >
            Tags
          </div>
          {showInsightsFileSetup && (
            <div
              onClick={() => {
                this.props.history.push(
                  "/settings/insights?cid=" + this.props.selected_client,
                );
              }}
              style={{ height: "58px", padding: "15px 20px 15px 35px" }}
              className={
                activeIndex === 1
                  ? "tag-settings-type-active"
                  : "tag-settings-type"
              }
            >
              Consumer Address File Setup
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default MySettingsNavigator;



// WEBPACK FOOTER //
// ./src/components/MySettings/navigator.jsx